import { render, staticRenderFns } from "./ruta-parejas.vue?vue&type=template&id=51a0f622&"
import script from "./ruta-parejas.vue?vue&type=script&lang=js&"
export * from "./ruta-parejas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports